import { useCheckoutContext } from "../../../context/useCheckoutContext";
import { configCardSections } from "../../../shared/constants/CheckoutContants";
import { ConfirmationDataModalEnum } from "../../../shared/constants/ConfirmationDataModalEnum";
export var useConfrontaValidationState = function () {
    var setCheckoutSection = useCheckoutContext().handlers.setCheckoutSection;
    var handleChangeView = function (view) {
        switch (view) {
            case ConfirmationDataModalEnum.START:
                setCheckoutSection(configCardSections.confrontaStart);
                break;
            case ConfirmationDataModalEnum.DOCUMENT_VALIDATION:
                setCheckoutSection(configCardSections.confrontaAuth);
                break;
            case ConfirmationDataModalEnum.QUESTIONS:
                setCheckoutSection(configCardSections.confrontaQuestions);
                break;
        }
    };
    return {
        handlers: {
            handleChangeView: handleChangeView,
        },
    };
};
